export default "__VITE_ASSET__DKVXjhZv__"